module.exports = __webpack_public_path__ + "static/media/7.160a3d50.jpg";